export { default } from "./AppFormControlLabel";

export type { AppFormControlLabelProps } from "./AppFormControlLabel";
